import css from './aio.less';
import type {ReactNode} from "react";
import { useMemo} from "react";
import cn from 'classnames';
import type {SelectOptions} from '../../helpers/react-helpers';
import { selectOptions} from '../../helpers/react-helpers';
import shortid from 'shortid';
import AioIcon from "./AioIcon";
import AioLabel from './AioLabel'
import {useTestId} from '../../contexts/testid'

interface Props extends Pick<React.ComponentProps<'select'>, 'onChange' | 'disabled' | 'onFocus' | 'onBlur' | 'defaultValue' | 'children'> {
    width?: number | string
    minWidth?: number | string
    maxWidth?: number | string
    icon?: string
    placeholder?: string
    label: ReactNode
    id?: string
    options?: Readonly<SelectOptions>
    value?: string | number | null
    loading?: boolean
    inline?: boolean
    required?: boolean
    testId?: string
}

const ARROW = (
    <svg className={css.arrow} xmlns="http://www.w3.org/2000/svg" width="16" height="16"
         viewBox="0 0 512 512">
        <path
            d="M98.9 184.7l1.8 2.1 136 156.5c4.6 5.3 11.5 8.6 19.2 8.6 7.7 0 14.6-3.4 19.2-8.6L411 187.1l2.3-2.6c1.7-2.5 2.7-5.5 2.7-8.7 0-8.7-7.4-15.8-16.6-15.8H112.6c-9.2 0-16.6 7.1-16.6 15.8 0 3.3 1.1 6.4 2.9 8.9z"/>
    </svg>
);

export default function AioSelect({width,minWidth,maxWidth,required,testId,...props}: Props) {
    const id = useMemo(() => props.id || shortid(), [props.id]);
    testId = useTestId(testId)

    return (
        <div className={cn({
            [css.wrapper]: true,
            [css.hasArrow]: true,
            [css.hasIcon]: props.icon,
            [css.disabled]: props.disabled,
            [css.loading]: props.loading,
            [css.inline]: props.inline,
        })} style={{width, minWidth, maxWidth}}>
            <select id={id} className={css.select} value={props.value === null ? '' : props.value}
                    onChange={props.onChange} disabled={props.disabled} onFocus={props.onFocus} onBlur={props.onBlur}
                    defaultValue={props.defaultValue} data-testid={testId}>
                {props.placeholder ? <option value="" hidden>{props.placeholder}</option> : null}
                {props.children}
                {selectOptions(props.options)}
            </select>
            {props.icon ? <AioIcon name={props.icon}/> : null}
            {ARROW}
            <AioLabel htmlFor={id} className={css.label} required={required}>{props.label}</AioLabel>
        </div>
    )
}
